// 初期化関連
import {convertAllInputData} from './formats.js';

$(() => {
    convertAllInputData();
});
